module.exports = __webpack_public_path__ + "img/41.fb990cf4.jpg";